import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class RoleRightService extends BaseService{
	constructor() {
		super('/RoleRight');
	}

	public getAllByFilter(filter: RoleRightFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class RoleRightFilter extends BaseFilter{
	constructor(idRole?: number | null) {
		super();
		this._idRole = idRole;
	}

	private _idRole?: number | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idRole != null ? { IdRole: this._idRole } : {}),
		);		
		return data;
	};
}